<template>
  <div class="cpt-hb-level-range">
    <div class="range-left">
      <div class="prefix">Lv.</div>
      <div class="value">
        <div class="input-wrapper">
          <input
            type="number"
            :value="range[0]"
            @input="($event) => handleUpdateValue($event, true)"
          />
        </div>
      </div>
    </div>
    <div class="range-divider"></div>
    <div class="range-right">
      <div class="prefix">Lv.</div>
      <div class="value">
        <div class="input-wrapper">
          <input
            type="number"
            :value="range[1]"
            @input="($event) => handleUpdateValue($event, false)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeyboxLevelRange',
  props: {
    range: {
      type: Array,
      default: () => ['0', '0'],
    },
  },
  methods: {
    handleUpdateValue({target: { value }}, isLeft) {
      let newVal
      if(isLeft) {
        newVal = [+value, Math.max(this.range[1], +value)]
      } else {
        newVal = [this.range[0], +value]
      }
      this.$emit('updateValue', newVal);
    },
  },
};
</script>

<style lang="scss">
.cpt-hb-level-range {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  padding: 0px 8px 8px 8px;

  .range-left,
  .range-right {
    display: flex;
    align-items: flex-start;
    gap: 1px;
    flex: 1 0 0;
  }

  .range-divider {
    width: 12px;
    height: 2px;
    background: $d-tx-2;
  }
  .prefix {
    display: flex;
    width: 32px;
    height: 44px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 5px 0px 0px 5px;
    background: $d-op-s4;

    color: $d-tx-2;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
  }
  .value {
    display: flex;
    height: 44px;
    padding: 12px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;

    border-radius: 0px 5px 5px 0px;
    background: $d-op-s2;
    .input-wrapper {
      background: transparent;
      border-radius: 5px;
      padding: 0 12px;
      width: 100%;
      height: 100%;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      height: 36px;
      cursor: text;
      position: relative;
      input {
        width: 0;
        -ms-flex: 1;
        flex: 1;
        height: 100%;
        background: transparent;
        color: $d-tx-2;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        display: block;
        text-align: center;
      }
      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }
}
</style>
